import api, { endpoints } from '@utils/api';

/**
 * Bizz+ AI chatbot — natural-language business data Q&A.
 * See biz-backend/src/modules/chatbot/AICHATBOT.md for the API spec.
 */

export const sendChatbotMessage = async ({ message, companyId, conversationId }) => {
  const response = await api.post(endpoints.chatbotMessage, {
    message,
    companyId,
    ...(conversationId ? { conversationId } : {}),
  });
  return response.data;
};

export const getChatbotConversations = async () => {
  const response = await api.get(endpoints.chatbotConversations);
  return response.data;
};

export const archiveChatbotConversation = async conversationId => {
  const response = await api.post(`${endpoints.chatbotConversations}/${conversationId}/archive`);
  return response.data;
};

export const getChatbotMessages = async (conversationId, { limit, before } = {}) => {
  const response = await api.get(`${endpoints.chatbotConversations}/${conversationId}/messages`, {
    params: {
      ...(limit ? { limit } : {}),
      ...(before ? { before } : {}),
    },
  });
  return response.data;
};
